(function () {
    'use strict';

    angular
        .module('aricControllers', ['services.authenticatedUser',
                                    'aricModule',
                                    'governanceProcessModule']);
})();
